let ShellService = function ($rootScope, $transitions) {
  function init() {
    $transitions.onSuccess({ }, (transition) => {
      $rootScope.isShellVisible = _.get(transition.to(), 'data.hideShell') !== true;
      $rootScope.currentState = transition.to();
    });
  }

  return { init };
};

ShellService.$inject = ['$rootScope', '$transitions'];

export default ShellService;



// WEBPACK FOOTER //
// ./client/app/common/layout/shell/shell.service.js